import { createSelector } from '@reduxjs/toolkit';

const selectKbaRoot = (state) => state.kba;

export const selectKba = createSelector(selectKbaRoot, (kba) => kba ?? {});

export const selectKbaError = createSelector(selectKbaRoot, (kba) => kba?.error ?? null);

export const selectIdmKbaResponse = createSelector(
    selectKbaRoot,
    (kba) => kba?.idmkbaResponse ?? null
);

export const selectSsnInfo = createSelector(selectKbaRoot, (kba) => kba?.ssnInfo ?? {});
